module.exports = __webpack_public_path__ + "static/img/14001005.50cd8357.png";